/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED NO CONTENT : STYLES --------------- ++++++++++ */
export default theme => ({
    noContent: {
        fontFamily: 'Verdana',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '350px',
        fontSize: pxToEm(24),
        color: theme.color.neutral.dark.swatch,
        border: '2px dashed #c5c5c5',
        borderRadius: pxToEm(10),
        background: 'radial-gradient(ellipse at center, rgba(245,245,245,1) 0%, rgba(232,232,232,1) 100%)',
        '& p':{
            padding: '0 30px',
            '& b':{
                fontWeight: 'bolder'
            }
        }
    }
});
